import gcla from '../assets/gcla.png';
import headerimg from '../assets/gcla-header.png';
import gcla1 from '../assets/gcla.png';
import george from '../assets/george.png';
import topimage from '../assets/gclatopimage.png';
import serverimage from '../assets/serverimage.png';
import circleimage from '../assets/circleimage.png';
import bluelinesimage from '../assets/bluelinesimage.png';
import lineofcodes from '../assets/lineofcodes.png';
import pcimg from '../assets/pcimg.png';
import visiga from '../assets/visiga.png';
import askofu from '../assets/askofu.png';
import hailmary from '../assets/hailmary.png';
import askofu3 from '../assets/askofu3.png';
import waseminari from '../assets/waseminari.png';
import visigalogo from '../assets/visigalogo.png';
import cathedral5 from '../assets/cathedral5.png';
import books from '../assets/books.png';
import visigalogo3 from '../assets/visigalogo3.png';
import stamp from '../assets/stamp.jpg';


export default {
  visigalogo3,
  stamp,
  gcla,
  headerimg,
  gcla1,
  george,
  topimage,
  serverimage,
  circleimage,
  bluelinesimage,
  lineofcodes,
  pcimg,
  visiga,
  askofu,
  askofu3,
  hailmary,
  waseminari,
  visigalogo,
  cathedral5,
  books
};
